<template>
  <div class="membership-package">
    <el-tabs v-model="activeTab">
      <!-- 会员等级设置 -->
      <el-tab-pane label="会员等级设置" name="levelSettings">
        <div class="level-settings">
          <el-button type="primary" @click="addLevel" style="margin-bottom: 20px;">
            <i class="el-icon-plus"></i> 添加会员等级
          </el-button>

          <el-table :data="memberLevels" border style="width: 100%">
            <el-table-column prop="level" label="等级" width="80"></el-table-column>
            <el-table-column prop="name" label="等级名称" width="120"></el-table-column>
            <el-table-column prop="upgradeCondition" label="升级条件" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.upgradeType === 'consumption'">
                  累计消费 ¥{{ scope.row.upgradeValue }}
                </span>
                <span v-else-if="scope.row.upgradeType === 'points'">
                  累计积分 {{ scope.row.upgradeValue }}
                </span>
                <span v-else-if="scope.row.upgradeType === 'purchase'">
                  购买会员卡
                </span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣" width="100">
              <template slot-scope="scope">
                {{ scope.row.discount * 10 }}折
              </template>
            </el-table-column>
            <el-table-column prop="benefits" label="会员权益">
              <template slot-scope="scope">
                <el-tag
                    v-for="(benefit, index) in scope.row.benefits"
                    :key="index"
                    size="small"
                    style="margin-right: 5px;"
                >
                  {{ benefit }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button size="mini" @click="editLevel(scope.$index)">编辑</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    @click="removeLevel(scope.$index)"
                    :disabled="scope.row.level === 1"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 等级编辑对话框 -->
          <el-dialog
              :title="isEditingLevel ? '编辑会员等级' : '添加会员等级'"
              :visible.sync="levelDialogVisible"
              width="50%"
              :append-to-body="true"
          >
            <el-form :model="currentLevel" label-width="120px">
              <el-form-item label="等级" prop="level">
                <el-input-number
                    v-model="currentLevel.level"
                    :min="1"
                    :max="10"
                    :disabled="isEditingLevel"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="等级名称" prop="name">
                <el-input v-model="currentLevel.name"></el-input>
              </el-form-item>

              <el-form-item label="升级方式">
                <el-radio-group v-model="currentLevel.upgradeType">
                  <el-radio label="consumption">累计消费</el-radio>
                  <el-radio label="points">累计积分</el-radio>
                  <el-radio label="purchase">购买会员卡</el-radio>
                  <el-radio label="none">无(手动设置)</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                  label="升级条件值"
                  v-if="currentLevel.upgradeType === 'consumption' || currentLevel.upgradeType === 'points'"
              >
                <el-input-number
                    v-model="currentLevel.upgradeValue"
                    :min="1"
                    :controls-position="right"
                ></el-input-number>
                <span style="margin-left: 10px;">
                  {{ currentLevel.upgradeType === 'consumption' ? '元' : '积分' }}
                </span>
              </el-form-item>

              <el-form-item label="折扣">
                <el-select v-model="currentLevel.discount" placeholder="请选择折扣">
                  <el-option label="9.5折" :value="0.95"></el-option>
                  <el-option label="9折" :value="0.9"></el-option>
                  <el-option label="8.5折" :value="0.85"></el-option>
                  <el-option label="8折" :value="0.8"></el-option>
                  <el-option label="7.5折" :value="0.75"></el-option>
                  <el-option label="7折" :value="0.7"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="会员权益">
                <el-select
                    v-model="currentLevel.benefits"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请添加会员权益"
                    style="width: 100%;"
                >
                  <el-option
                      v-for="(item, index) in defaultBenefits"
                      :key="index"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="levelDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveLevel">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>

      <!-- 会员卡包管理 -->
      <el-tab-pane label="会员卡包管理" name="packageManagement">
        <div class="package-management">
          <el-button type="primary" @click="addPackage" style="margin-bottom: 20px;">
            <i class="el-icon-plus"></i> 添加会员卡包
          </el-button>

          <el-table :data="membershipPackages" border style="width: 100%">
            <el-table-column prop="name" label="卡包名称" width="180"></el-table-column>
            <el-table-column prop="type" label="卡包类型" width="120">
              <template slot-scope="scope">
                {{ packageTypeMap[scope.row.type] }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="120">
              <template slot-scope="scope">
                ¥{{ scope.row.price }}
              </template>
            </el-table-column>
            <el-table-column prop="validity" label="有效期" width="120">
              <template slot-scope="scope">
                {{ scope.row.validity }}天
              </template>
            </el-table-column>
            <el-table-column prop="services" label="包含服务">
              <template slot-scope="scope">
                <el-tag
                    v-for="(service, index) in scope.row.services"
                    :key="index"
                    size="small"
                    style="margin-right: 5px;"
                >
                  {{ service.name }} × {{ service.count }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button size="mini" @click="editPackage(scope.$index)">编辑</el-button>
                <el-button size="mini" type="danger" @click="removePackage(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 卡包编辑对话框 -->
          <el-dialog
              :title="isEditingPackage ? '编辑会员卡包' : '添加会员卡包'"
              :visible.sync="packageDialogVisible"
              width="60%"
              :append-to-body="true"
          >
            <el-form :model="currentPackage" label-width="120px">
              <el-form-item label="卡包名称" prop="name">
                <el-input v-model="currentPackage.name"></el-input>
              </el-form-item>

              <el-form-item label="卡包类型">
                <el-select v-model="currentPackage.type" placeholder="请选择卡包类型">
                  <el-option
                      v-for="(label, value) in packageTypeMap"
                      :key="value"
                      :label="label"
                      :value="value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="价格">
                <el-input-number
                    v-model="currentPackage.price"
                    :min="100"
                    :max="10000"
                    :step="100"
                    controls-position="right"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="有效期">
                <el-input-number
                    v-model="currentPackage.validity"
                    :min="30"
                    :max="365"
                    :step="30"
                    controls-position="right"
                ></el-input-number>
                <span style="margin-left: 10px;">天</span>
              </el-form-item>

              <el-form-item label="包含服务">
                <div class="service-list">
                  <div class="service-item" v-for="(service, index) in currentPackage.services" :key="index">
                    <el-select
                        v-model="service.id"
                        placeholder="选择服务"
                        style="width: 200px; margin-right: 10px;"
                    >
                      <el-option
                          v-for="item in availableServices"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-input-number
                        v-model="service.count"
                        :min="1"
                        :max="100"
                        controls-position="right"
                        style="width: 120px; margin-right: 10px;"
                    ></el-input-number>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        size="mini"
                        @click="removeService(index)"
                    ></el-button>
                  </div>
                  <el-button
                      type="primary"
                      size="small"
                      @click="addService"
                      style="margin-top: 10px;"
                  >
                    <i class="el-icon-plus"></i> 添加服务
                  </el-button>
                </div>
              </el-form-item>

              <el-form-item label="描述">
                <el-input v-model="currentPackage.description" type="textarea"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="packageDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="savePackage">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'MembershipSettings',
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 'levelSettings',
      // 会员等级相关数据
      memberLevels: JSON.parse(JSON.stringify(this.shop.membershipSettings?.levels || [
        {
          level: 1,
          name: '普通会员',
          upgradeType: 'none',
          upgradeValue: 0,
          discount: 1,
          benefits: ['基础折扣']
        }
      ])),
      levelDialogVisible: false,
      isEditingLevel: false,
      editingLevelIndex: -1,
      currentLevel: {
        level: 1,
        name: '',
        upgradeType: 'none',
        upgradeValue: 0,
        discount: 1,
        benefits: []
      },
      defaultBenefits: [
        '生日特权',
        '专属优惠',
        '优先预约',
        '免费WiFi',
        '停车优惠',
        '积分加倍'
      ],

      // 会员卡包相关数据
      membershipPackages: JSON.parse(JSON.stringify(this.shop.membershipSettings?.packages || [])),
      packageDialogVisible: false,
      isEditingPackage: false,
      editingPackageIndex: -1,
      currentPackage: {
        name: '',
        type: 'bath',
        price: 1000,
        validity: 90,
        services: [],
        description: ''
      },
      packageTypeMap: {
        'bath': '洗浴套餐',
        'massage': '按摩套餐',
        'combo': '综合套餐',
        'custom': '自定义套餐'
      },
      availableServices: [
        {id: 'bath1', name: '标准洗浴'},
        {id: 'bath2', name: '豪华洗浴'},
        {id: 'massage1', name: '中式按摩'},
        {id: 'massage2', name: '泰式按摩'},
        {id: 'sauna', name: '桑拿体验'},
        {id: 'spa', name: 'SPA护理'}
      ]
    }
  },
  methods: {
    // 会员等级方法
    addLevel() {
      this.isEditingLevel = false
      this.currentLevel = {
        level: this.memberLevels.length + 1,
        name: '',
        upgradeType: 'none',
        upgradeValue: 0,
        discount: 1,
        benefits: []
      }
      this.levelDialogVisible = true
    },
    editLevel(index) {
      this.isEditingLevel = true
      this.editingLevelIndex = index
      this.currentLevel = JSON.parse(JSON.stringify(this.memberLevels[index]))
      this.levelDialogVisible = true
    },
    removeLevel(index) {
      this.$confirm('确定要删除此会员等级吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.memberLevels.splice(index, 1)
        this.$message.success('删除成功')
      })
    },
    saveLevel() {
      if (!this.currentLevel.name) {
        this.$message.error('请输入等级名称')
        return
      }

      if (this.isEditingLevel) {
        this.memberLevels.splice(this.editingLevelIndex, 1, this.currentLevel)
      } else {
        this.memberLevels.push(this.currentLevel)
      }

      this.levelDialogVisible = false
      this.saveSettings()
    },

    // 会员卡包方法
    addPackage() {
      this.isEditingPackage = false
      this.currentPackage = {
        name: '',
        type: 'bath',
        price: 1000,
        validity: 90,
        services: [],
        description: ''
      }
      this.packageDialogVisible = true
    },
    editPackage(index) {
      this.isEditingPackage = true
      this.editingPackageIndex = index
      this.currentPackage = JSON.parse(JSON.stringify(this.membershipPackages[index]))
      this.packageDialogVisible = true
    },
    removePackage(index) {
      this.$confirm('确定要删除此会员卡包吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.membershipPackages.splice(index, 1)
        this.$message.success('删除成功')
        this.saveSettings()
      })
    },
    addService() {
      this.currentPackage.services.push({
        id: '',
        name: '',
        count: 1
      })
    },
    removeService(index) {
      this.currentPackage.services.splice(index, 1)
    },
    savePackage() {
      if (!this.currentPackage.name) {
        this.$message.error('请输入卡包名称')
        return
      }

      if (this.currentPackage.services.length === 0) {
        this.$message.error('请至少添加一个服务')
        return
      }

      // 完善服务信息
      this.currentPackage.services.forEach(service => {
        const found = this.availableServices.find(item => item.id === service.id)
        if (found) {
          service.name = found.name
        }
      })

      if (this.isEditingPackage) {
        this.membershipPackages.splice(this.editingPackageIndex, 1, this.currentPackage)
      } else {
        this.membershipPackages.push(this.currentPackage)
      }

      this.packageDialogVisible = false
      this.saveSettings()
    },

    // 保存设置
    saveSettings() {
      const settings = {
        levels: this.memberLevels,
        packages: this.membershipPackages
      }
      this.$emit('save', settings)
    }
  }
}
</script>

<style scoped>
.membership-package {
  padding: 20px;
}

.level-settings,
.package-management {
  padding: 10px;
}

.service-list {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
}

.service-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.service-item:last-child {
  margin-bottom: 0;
}

.el-tag {
  margin-right: 5px;
}
</style>